var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"onboarding"}},[_c('el-header',{staticClass:"navigation-bar"},[_c('HeaderContent')],1),_c('el-main',{staticClass:"main-outlet"},[_c('router-view')],1),_c('el-footer',[_c('FooterContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }